import { pageUrl } from '../data/pageMeta';

const setAttr = (selector, attr, value) => {
  const el = document.querySelector(selector);
  if (el) el.setAttribute(attr, value);
};

export function setPageMeta(meta, pathname) {
  const url = pageUrl(pathname);
  const robots = meta.robots || 'index,follow';

  document.title = meta.title;
  setAttr('meta[name="description"]', 'content', meta.description);
  setAttr('meta[name="robots"]', 'content', robots);
  setAttr('meta[property="og:title"]', 'content', meta.title);
  setAttr('meta[property="og:description"]', 'content', meta.description);
  setAttr('meta[property="og:url"]', 'content', url);
  setAttr('meta[property="twitter:title"]', 'content', meta.title);
  setAttr('meta[property="twitter:description"]', 'content', meta.description);
  setAttr('meta[property="twitter:url"]', 'content', url);

  let canonical = document.querySelector('link[rel="canonical"]');
  if (!canonical) {
    canonical = document.createElement('link');
    canonical.setAttribute('rel', 'canonical');
    document.head.appendChild(canonical);
  }
  canonical.setAttribute('href', url);
}
